import React from "react";
import "./footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKaggle, faHackerrank } from "@fortawesome/free-brands-svg-icons";
import LeetCodeLogo from "../../assets/leetcode-svgrepo-com.svg";
import { Tooltip } from "react-tooltip";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Saswat</h1>
        <ul className="footer__list">
          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>
          <li>
            <a href="#credentials" className="footer__link">
              Credentials
            </a>
          </li>
        </ul>
        <div className="footer__social">
          <a
            href="https://www.linkedin.com/in/saswat-seth-0a782223b/"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="linkedin-tooltip"
          >
            <i className="bx bxl-linkedin"></i>
          </a>
          <Tooltip id="linkedin-tooltip" place="top" content="LinkedIn" />

          <a
            href="https://github.com/Cyberoctane29"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="github-tooltip"
          >
            <i className="bx bxl-github"></i>
          </a>
          <Tooltip id="github-tooltip" place="top" content="GitHub" />

          <a
            href="https://www.kaggle.com/saswatsethda"
            className="footer__social-link kaggle-icon"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="kaggle-tooltip"
          >
            <FontAwesomeIcon icon={faKaggle} />
          </a>
          <Tooltip id="kaggle-tooltip" place="top" content="Kaggle" />
          <a
            href="https://leetcode.com/u/cyberoctane/"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="leetcode-tooltip"
          >
            <img
              src={LeetCodeLogo}
              alt="LeetCode"
              className="social-icon-white"
            />
          </a>
          <Tooltip id="leetcode-tooltip" place="top" content="LeetCode" />

          <a
            href="https://www.hackerrank.com/profile/saswatsethTechie"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="hackerrank-tooltip"
          >
            <FontAwesomeIcon icon={faHackerrank} />
          </a>
          <Tooltip id="hackerrank-tooltip" place="top" content="HackerRank" />
        </div>
        <span className="footer__copy">
          &#169; Saswat Seth. All rights reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
